module.exports = __webpack_public_path__ + "static/media/corrin-icon.4af9df9e.png";